import React, { useMemo } from 'react';
import useExternalProjects from '../../hooks/useExternalProjects';

import { Project } from '../../utils/models';

import { PaginationResponse } from './withProjects';
import { ProjectsResponse } from '../../hooks/useInternalProjects';

export interface ExternalProjectsProps extends PaginationResponse<ProjectsResponse> {
	customerProjectsLoading: boolean;
	customerProjectsError: Error | null;
	refreshCustomerProjects: () => void;
	customerProjectsLastUpdated: number;
	projects: Project[];
}

export default function withCustomerProjects(Component: any): React.FC<any> {
	return function WithCustomerProjects(props): JSX.Element {
		const { data, error, dataUpdatedAt, fetchNextPage, fetchPreviousPage, isFetching, hasPreviousPage, hasNextPage, refetch } = useExternalProjects();

		const fetchedCount = useMemo(() => {
			return data.pages.reduce((total, page) => total + page.projects.length, 0) || 0;
		}, [data]);

		const totalProjects = useMemo(() => {
			return data.pages[0].totalProjects;
		}, [data]);

		const projects = useMemo(() => {
			return data.pages.flatMap((page) => page.projects);
		}, [data.pages]);

		return (
			<Component
				dataLength={fetchedCount}
				pages={data.pages}
				hasNextPage={!!hasNextPage}
				hasPreviousPage={!!hasPreviousPage}
				fetchNextPage={() => fetchNextPage()}
				fetchPreviousPage={() => fetchPreviousPage()}
				refreshCustomerProjects={refetch}
				totalProjects={totalProjects}
				
				projects={projects}
				customerProjectsLoading={isFetching}
				customerProjectsError={error}
				customerProjectsLastUpdated={dataUpdatedAt}				

				{...props}
			/>
		);
	};
}

